
import { NavLink, Outlet } from "react-router-dom";

function AppLayout() {
  return (
    <>
      <nav className="navbar navbar-expand navbar-light bg-light border-bottom px-3">
        <span className="navbar-brand fw-semibold">
          Website Knowledge Base
        </span>

        <div className="navbar-nav ms-auto flex-row gap-3">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `nav-link ${isActive ? "active fw-semibold" : ""}`
            }
          >
            Crawler & Knowledge Base
          </NavLink>

          <NavLink
            to="/configuration"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active fw-semibold" : ""}`
            }
          >
            Configuration
          </NavLink>
        </div>
      </nav>

      <main className="container-fluid py-0">
        <Outlet />
      </main>
    </>
  );
}

export default AppLayout;